import {
  type AddThemeAction,
  AddThemeActionType,
  ErrorType,
  LoadedType,
  RequestType,
} from 'common/actions/ideasConfiguration';

import requestReducerFactory, { type RequestState } from './requestReducerFactory';
export { defaultState } from './requestReducerFactory';

import type { IdeasConfiguration } from 'common/api/endpoints/idea';

export type IdeasConfigurationState = RequestState<IdeasConfiguration>;

const ideasConfigurationReducer = requestReducerFactory<IdeasConfiguration>(
  RequestType,
  LoadedType,
  ErrorType,
);

export default function reducer(
  state: IdeasConfigurationState,
  action: Action,
): IdeasConfigurationState {
  switch (action.type) {
    case AddThemeActionType: {
      const addThemeAction = action as AddThemeAction;
      if (!state.data?.themes) {
        return state;
      }

      const existingTheme = state.data.themes.find((t) => t._id === addThemeAction.theme._id);
      const themesWithNoDuplicate = existingTheme
        ? state.data.themes.filter((t) => t._id !== addThemeAction.theme._id)
        : state.data.themes;

      return {
        ...state,
        data: {
          ...state.data,
          themes: [...themesWithNoDuplicate, { ...existingTheme, ...addThemeAction.theme }].sort(
            (a, b) => a.created.localeCompare(b.created),
          ),
        },
      };
    }

    default: {
      return ideasConfigurationReducer(state, action);
    }
  }
}
